import React from 'react';
import Transfer from 'components/Tvendo/Inventory/Operations/Kardex/KardexSharedFile';
import { ConstantPermissions } from 'contexts/useConstant';

export default function () {
  return (
    <Transfer
      title="transferencias"
      excelName="transferencias"
      type="TR" // TR = transferencia
      entity="logi/transfer"
      permissions={{
        store: ConstantPermissions.LOGI_TRANSFERS_STORE,
        show: ConstantPermissions.LOGI_TRANSFERS_SHOW,
        delete: ConstantPermissions.LOGI_TRANSFERS_DELETED
      }}
    />
  );
}
